import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';
import { ANTD_GRAY } from '../entity/shared/constants';

const SpinnerContainer = styled.div`
    height: 2px;
    width: 100%;
    overflow: hidden;
`;

const SkeletonInput = styled(Skeleton.Input)`
    &&& {
        width: 100%;
        height: 2px;
        &.ant-skeleton-input::after {
            background: linear-gradient(90deg, ${ANTD_GRAY[12]} 25%, ${ANTD_GRAY[11]} 37%, ${ANTD_GRAY[12]} 63%);
        }
    }
`;

export const ComponentSpinner: React.FC = () => {
    return (
        <SpinnerContainer>
            <SkeletonInput active />
        </SpinnerContainer>
    );
};
